var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "46px",
    viewBox: "0 0 47 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "register") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-1.8%",
    y: "-2.4%",
    width: "103.7%",
    height: "105.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "19.3-Speed-Bet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sprint-19.3.1-priority-access",
    transform: "translate(-573.000000, -783.000000)",
    fill: "#32302F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Key-Content",
    filter: "url(#filter-1)",
    transform: "translate(147.000000, 126.044423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(438.492537, 662.455577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(-0.000000, 3.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "register",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59687036,10.5391038 C8.61967911,10.5391038 8.63843297,10.5277591 8.66073486,10.5261239 C11.2052314,10.5192949 13.3740946,8.66372607 13.7948417,6.13364354 C14.2155888,3.60356101 12.7656088,1.13626354 10.3624663,0.293086614 C7.95932385,-0.550090312 5.30332575,0.476565954 4.07521953,2.72337499 C2.84711331,4.97018402 3.40478497,7.78239666 5.39533319,9.38041095 C2.13986681,10.7001592 0.00508884881,13.880394 0,17.4179805 C0.00178732555,19.0440173 1.30865132,20.3617943 2.92144575,20.363822 L8.38895596,20.363822 C8.87883631,20.363822 9.27596281,19.9634348 9.27596281,19.4695323 C9.27596281,18.9756297 8.87883631,18.5752425 8.38895596,18.5752425 L2.92144575,18.5752425 C2.28790259,18.5744537 1.77457224,18.0567257 1.77401369,17.4179805 C1.77825948,13.6206563 4.83047074,10.5433845 8.59687036,10.5391038 Z M8.59687036,1.89709657 C9.97051308,1.89684859 11.2090254,2.73094141 11.7348188,4.01039036 C12.2606122,5.28983931 11.9701248,6.76263983 10.9988272,7.74194163 C10.0275296,8.72124344 8.56673187,9.01415996 7.29768676,8.48408762 C6.02864165,7.95401529 5.20130453,6.70535895 5.20150949,5.32043774 C5.20374376,3.43075237 6.72257423,1.89940562 8.59687036,1.89709657 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5572891,9.00756878 C12.9511955,9.00736209 10.6016025,10.5899711 9.60416106,13.0174012 C8.60671961,15.4448313 9.15786743,18.2390204 11.0005959,20.0969958 C12.8433244,21.9549712 15.6147237,22.5108202 18.0224481,21.5053419 C20.4301725,20.4998636 22,18.1310786 22,15.5035872 C21.9959224,11.9177991 19.1138751,9.01190553 15.5572891,9.00756878 L15.5572891,9.00756878 Z M15.5572891,20.2111284 C13.6687263,20.2113351 11.9660095,19.0645106 11.2431457,17.3054394 C10.5202819,15.5463682 10.9196341,13.521487 12.2549772,12.1750337 C13.5903203,10.8285804 15.598668,10.4257294 17.3434922,11.1543374 C19.0883164,11.8829454 20.2259863,13.5995181 20.2259863,15.5035872 C20.2231939,18.1022067 18.1347454,20.2082599 15.5572891,20.2116394 L15.5572891,20.2111284 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2677793,14.6092975 L16.444296,14.6092975 L16.444296,12.7696157 C16.444296,12.2757132 16.0471695,11.875326 15.5572891,11.875326 C15.0674088,11.875326 14.6702823,12.2757132 14.6702823,12.7696157 L14.6702823,14.6092975 L12.8455825,14.6092975 C12.3557021,14.6092975 11.9585756,15.0096846 11.9585756,15.5035872 C11.9585756,15.9974898 12.3557021,16.397877 12.8455825,16.397877 L14.6702823,16.397877 L14.6702823,18.2375587 C14.6702823,18.7314613 15.0674088,19.1318485 15.5572891,19.1318485 C16.0471695,19.1318485 16.444296,18.7314613 16.444296,18.2375587 L16.444296,16.397877 L18.2677793,16.397877 C18.7576597,16.397877 19.1547862,15.9974898 19.1547862,15.5035872 C19.1547862,15.0096846 18.7576597,14.6092975 18.2677793,14.6092975 L18.2677793,14.6092975 Z",
    id: "Path"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.dfdffe1f8e88e2f40c01e8f973c85cf1.svg";
export { ForwardRef as ReactComponent };